import initializeStore from '../store/configureStore';

/**
 * Based of the example on https://github.com/zeit/next.js/tree/canary/examples/with-redux
 */
const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';

/* istanbul ignore file */
export function getOrCreateStore(initialState, helpers) {
  // Always make a new store if server, otherwise state is shared between requests
  if (typeof window === 'undefined') {
    return initializeStore(initialState, helpers);
  }

  // Create store if unavailable on the client and set it on the window object
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = initializeStore(initialState, helpers);
  }
  return window[__NEXT_REDUX_STORE__];
}
